export enum POcomparisonTypes {
  GET_COMODITY_LIST_BY_PO = '@@POcomparison/GET_COMODITY_LIST_BY_PO',
  GET_COMODITY_LIST_BY_PO_SUCCESS = '@@purchaseOrders/GET_COMODITY_LIST_BY_PO_SUCCESS',
  GET_COMODITY_LIST_BY_PO_FAIL = '@@POcomparison/GET_COMODITY_LIST_BY_PO_FAIL',
}
